import steam from "../../Img/steam.svg";
import playstation from "../../Img/playstation.svg";
import epicgames from "../../Img/epicgames.svg";
import appstore from "../../Img/appstore.svg";
import goggalaxy from "../../Img/goggalaxy.svg";
import googleplay from "../../Img/googleplay.svg";
import itchio from "../../Img/itchio.svg";
import xbox from "../../Img/xbox.svg";
import switchnintendo from "../../Img/switchnintendo.svg";

export const ICON_CONFIG = {
  steam: steam,
  "playstation-store": playstation,
  "apple-appstore": appstore,
  "xbox-store": xbox,
  gog: goggalaxy,
  nintendo: switchnintendo,
  xbox360: xbox,
  "google-play": googleplay,
  itch: itchio,
  "epic-games": epicgames,
};
